// interface IconTypes {
//   [key: string]: React.FC<React.SVGProps<SVGSVGElement>>;
// }

// 공통 아이콘
export const IconImg = {
  AddList: require("assets/icons/add-list.svg").ReactComponent,
  ArrowUp: require("assets/icons/arrow-up.svg").ReactComponent,
  ArrowDown: require("assets/icons/arrow-down.svg").ReactComponent,
  AlignPrettify: require("assets/icons/align-prettify.svg").ReactComponent,
  PlusCircleBtn: require("assets/icons/plus-circle-btn.svg").ReactComponent,
  PlusCircleSmallBtn: require("assets/icons/plus-circle-small.svg")
    .ReactComponent,
  MinusCircleBtn: require("assets/icons/minus-circle-btn.svg").ReactComponent,
  CloseCircleBtn: require("assets/icons/close-circle-btn.svg").ReactComponent,
  Folder: require("assets/icons/folder.svg").ReactComponent,
  Database01: require("assets/icons/database-01.svg").ReactComponent,
  Users02: require("assets/icons/users-02.svg").ReactComponent,
  RadioChecked: require("assets/icons/radio-checked.svg").ReactComponent,
  RadioUnchecked: require("assets/icons/radio-unchecked.svg").ReactComponent,
  CheckBoxOn: require("assets/icons/checked.svg").ReactComponent,
  CheckBoxOff: require("assets/icons/unChecked.svg").ReactComponent,
  MessagePlusSquare: require("assets/icons/message-plus-square.svg")
    .ReactComponent,
  FolderThin: require("assets/icons/folder-thin.svg").ReactComponent,
  Plus: require("assets/icons/plus.svg").ReactComponent,
  SearchMd: require("assets/icons/search-md.svg").ReactComponent,
  ChevronUp: require("assets/icons/chevron-up.svg").ReactComponent,
  ChevronDown: require("assets/icons/chevron-down.svg").ReactComponent,
  ChevronDownWhite: require("assets/icons/chevron-down-white.svg")
    .ReactComponent,
  ChevronDownBlue: require("assets/icons/chevron-down-blue.svg").ReactComponent,
  ChevronDownBlue01: require("assets/icons/chevron-down-blue-01.svg")
    .ReactComponent,
  RefreshCcw01: require("assets/icons/refresh-ccw-01.svg").ReactComponent,
  RefreshCcw01Black: require("assets/icons/refresh-ccw-black.svg")
    .ReactComponent,
  Copy07: require("assets/icons/copy-07.svg").ReactComponent,
  Close: require("assets/icons/close.svg").ReactComponent,
  CloseSmall: require("assets/icons/close-small.svg").ReactComponent,
  XClose: require("assets/icons/x-close.svg").ReactComponent,
  XCircle: require("assets/icons/x-circle.svg").ReactComponent,
  XSquare: require("assets/icons/x-square.svg").ReactComponent,
  XCircleRed: require("assets/icons/x-circle-red.svg").ReactComponent,
  ArrowSquareDown: require("assets/icons/arrow-square-down.svg").ReactComponent,
  Upload01: require("assets/icons/upload-01.svg").ReactComponent,
  Download01: require("assets/icons/download-01.svg").ReactComponent,
  FolderPlus: require("assets/icons/folder-plus.svg").ReactComponent,
  DotsVertical: require("assets/icons/dots-vertical.svg").ReactComponent,
  UploadCloud01: require("assets/icons/upload-cloud-01.svg").ReactComponent,
  DownloadCloud01: require("assets/icons/download-cloud-01.svg").ReactComponent,
  Download03: require("assets/icons/upload-03.svg").ReactComponent,
  Upload03: require("assets/icons/download-03.svg").ReactComponent,
  ChevronRightDouble: require("assets/icons/chevron-right-double.svg")
    .ReactComponent,
  ChevronRightBlue: require("assets/icons/chevron-right.svg").ReactComponent,
  ChevronLeftBlue: require("assets/icons/chevron-left.svg").ReactComponent,
  Edit05: require("assets/icons/edit-05.svg").ReactComponent,
  Edit06: require("assets/icons/edit-06.svg").ReactComponent,
  Trash01: require("assets/icons/trash-01.svg").ReactComponent,
  Trash01Black: require("assets/icons/trash-01-black.svg").ReactComponent,
  Trash04: require("assets/icons/trash-04.svg").ReactComponent,
  ArrowLeft: require("assets/icons/arrow-left.svg").ReactComponent,
  ArrowBlockRight: require("assets/icons/arrow-block-right.svg").ReactComponent,
  Eye: require("assets/icons/eye.svg").ReactComponent,
  EyeOff: require("assets/icons/eye-off.svg").ReactComponent,
  Copy02: require("assets/icons/copy-02.svg").ReactComponent,
  Setting02: require("assets/icons/setting-02.svg").ReactComponent,
  Setting03: require("assets/icons/setting-03.svg").ReactComponent,
  Repeat03: require("assets/icons/repeat-03.svg").ReactComponent,
  SwitchHorizontal02: require("assets/icons/switch-horizontal-02.svg")
    .ReactComponent,
  Lock01: require("assets/icons/lock-01.svg").ReactComponent,
  Lock02: require("assets/icons/lock-02.svg").ReactComponent,
  LockUnlocked01: require("assets/icons/lock-unlocked-01.svg").ReactComponent,
  LockUnlocked05: require("assets/icons/lock-unlocked-05.svg").ReactComponent,
  ArrowCircleLeft: require("assets/icons/arrow-circle-left.svg").ReactComponent,
  ArrowCircleUp: require("assets/icons/arrow-circle-up.svg").ReactComponent,
  ArrowDescending: require("assets/icons/arrow-descending.svg").ReactComponent,
  ArrowCircleDown: require("assets/icons/arrow-circle-down.svg").ReactComponent,
  TypeSquare: require("assets/icons/type-square.svg").ReactComponent,
  SpacingWidth02: require("assets/icons/spacing-width-02.svg").ReactComponent,
  MinusCircle: require("assets/icons/minus-circle.svg").ReactComponent,
  CheckSquareBroken: require("assets/icons/check-square-broken.svg")
    .ReactComponent,
  CheckSquare: require("assets/icons/check-square.svg").ReactComponent,
  CheckCircle: require("assets/icons/check-circle.svg").ReactComponent,
  ParagraphSpacing: require("assets/icons/paragraph-spacing.svg")
    .ReactComponent,
  FileNumeric: require("assets/icons/file-numeric.svg").ReactComponent,
  FileAttachment03: require("assets/icons/file-attachment-03.svg")
    .ReactComponent,
  File02: require("assets/icons/file-02.svg").ReactComponent,
  File04: require("assets/icons/file-04.svg").ReactComponent,
  FileX03: require("assets/icons/file-x-03.svg").ReactComponent,
  PlusCircle: require("assets/icons/plus-circle.svg").ReactComponent,
  PlusSquare: require("assets/icons/plus-square.svg").ReactComponent,
  Square: require("assets/icons/square.svg").ReactComponent,
  Calculator: require("assets/icons/calculator.svg").ReactComponent,
  RefreshCw05: require("assets/icons/refresh-cw-05.svg").ReactComponent,
  RefreshCwGray: require("assets/icons/refresh-cw-05-gray.svg").ReactComponent,
  Save03: require("assets/icons/save-03.svg").ReactComponent,
  LayersThree01: require("assets/icons/layers-three-01.svg").ReactComponent,
  LayoutAlt04: require("assets/icons/layout-alt-04.svg").ReactComponent,
  LayoutGrid02: require("assets/icons/layout-grid-02.svg").ReactComponent,
  HorizontalBarChart01: require("assets/icons/horizontal-bar-chart-01.svg")
    .ReactComponent,
  ArrowCircleBrokenUpRight:
    require("assets/icons/arrow-circle-broken-up-right.svg").ReactComponent,
  CheckDone01: require("assets/icons/check-done-01.svg").ReactComponent,
  LineChartUp05: require("assets/icons/line-chart-up-05.svg").ReactComponent,
  Columns01: require("assets/icons/columns-01.svg").ReactComponent,
  CpuChip01: require("assets/icons/cpu-chip-01.svg").ReactComponent,
  BracketsPlus: require("assets/icons/brackets-plus.svg").ReactComponent,
  Move: require("assets/icons/move.svg").ReactComponent,
  BarLineChart: require("assets/icons/bar-line-chart.svg").ReactComponent,
  Eraser: require("assets/icons/eraser.svg").ReactComponent,
  Dropper: require("assets/icons/dropper.svg").ReactComponent,
  Triangle: require("assets/icons/triangle.svg").ReactComponent,
  FilterFunnel02: require("assets/icons/filter-funnel-02.svg").ReactComponent,
  BarChartSquareUp: require("assets/icons/bar-chart-square-up.svg")
    .ReactComponent,
  Polygon1: require("assets/icons/polygon-1.svg").ReactComponent,
  Up: require("assets/icons/up.svg").ReactComponent,
  Down: require("assets/icons/down.svg").ReactComponent,
  CalendarDate: require("assets/icons/calendar-date.svg").ReactComponent,
  LeftLookup: require("assets/icons/left-lookup.svg").ReactComponent,
  RightLookup: require("assets/icons/right-lookup.svg").ReactComponent,
  InnerLookup: require("assets/icons/inner-lookup.svg").ReactComponent,
  OuterLookup: require("assets/icons/outer-lookup.svg").ReactComponent,
  Dataflow01: require("assets/icons/dataflow-01.svg").ReactComponent,
  Dataflow03: require("assets/icons/dataflow-03.svg").ReactComponent,
  Lightbulb04: require("assets/icons/lightbulb-04.svg").ReactComponent,
  Clock: require("assets/icons/clock.svg").ReactComponent,
  UserCircle: require("assets/icons/user-circle.svg").ReactComponent,
  LogOut04: require("assets/icons/log-out-04.svg").ReactComponent,
  LinkExternal: require("assets/icons/link-external.svg").ReactComponent,
  LinkExternalGray: require("assets/icons/link-external-gray.svg")
    .ReactComponent,
  LinkExternalWhite: require("assets/icons/link-external-white.svg")
    .ReactComponent,
  List: require("assets/icons/list.svg").ReactComponent,
  NewCircle: require("assets/icons/new-circle.svg").ReactComponent,
  CheckCircleBlue: require("assets/icons/check-circle-blue.svg").ReactComponent,
  ArrowCircleUpBlack: require("assets/icons/arrow-circle-up-black.svg")
    .ReactComponent,
  ArrowCircleDownBlack: require("assets/icons/arrow-circle-down-black.svg")
    .ReactComponent,
  Toggle03Left: require("assets/icons/toggle-03-left.svg").ReactComponent,
  ChevronDownDouble: require("assets/icons/chevron-down-double.svg")
    .ReactComponent,
  AlertCircle: require("assets/icons/alert-circle.svg").ReactComponent,
  AlertTriangle: require("assets/icons/alert-triangle.svg").ReactComponent,
  MarkerPin02: require("assets/icons/marker-pin-02.svg").ReactComponent,
  CalendarCheck: require("assets/icons/calendar-check-01.svg").ReactComponent,
  Play: require("assets/icons/play.svg").ReactComponent,
  InfoCircle: require("assets/icons/info-circle.svg").ReactComponent,
  Loading: require("assets/icons/loading-01.svg").ReactComponent,
  ClockFastForward: require("assets/icons/clock-fast-forward.svg")
    .ReactComponent,
  Database: require("assets/icons/database.svg").ReactComponent,
  DatabaseCheck: require("assets/icons/database-check.svg").ReactComponent,
  DatabaseTerminated: require("assets/icons/database-terminated.svg")
    .ReactComponent,
  Target04: require("assets/icons/target-04.svg").ReactComponent,
  Tool02: require("assets/icons/tool-02.svg").ReactComponent,
  LinkExternal02: require("assets/icons/link-external-02.svg").ReactComponent,
  Moon02: require("assets/icons/moon-02.svg").ReactComponent,
  Sun: require("assets/icons/sun.svg").ReactComponent,
  Ellipse: require("assets/icons/ellipse.svg").ReactComponent,
  AutoNumbering: require("assets/icons/auto-numbering.svg").ReactComponent,
  EditDetailsDelete: require("assets/icons/edit-details-delete.svg")
    .ReactComponent,
  Maximize01: require("assets/icons/maximize-01.svg").ReactComponent,
  SearchLg: require("assets/icons/search-lg.svg").ReactComponent,
  X: require("assets/icons/x.svg").ReactComponent,
  Regacy_CheckboxChecked: require("assets/icons/checkbox-cheked.svg")
    .ReactComponent,
  Regacy_CheckboxUnchecked: require("assets/icons/checkbox-unchecked.svg")
    .ReactComponent,
  CloseGray: require("assets/icons/close-gray.svg").ReactComponent,
  MarkerPinOrange: require("assets/icons/marker-pin-orange.svg").ReactComponent,
  MarkerPinBlack: require("assets/icons/marker-pin-black.svg").ReactComponent,
  MoveIconGray: require("assets/icons/move-icon_gray.svg").ReactComponent,
  Upload02: require("assets/icons/upload-02.svg").ReactComponent,
  RefreshCw01: require("assets/icons/refresh-cw-01.svg").ReactComponent,
  HelpCircle: require("assets/icons/help-circle.svg").ReactComponent,
  Command: require("assets/icons/command.svg").ReactComponent,
  AscendingHovered: require("assets/icons/ascending-hovered.svg")
    .ReactComponent,
  AscendingPressed: require("assets/icons/ascending-pressed.svg")
    .ReactComponent,
  DescendingHovered: require("assets/icons/descending-hovered.svg")
    .ReactComponent,
  DescendingPressed: require("assets/icons/descending-pressed.svg")
    .ReactComponent,
};

export const ImgRoute = {
  computeManual: require("assets/image/compute-manual.png"),
  computeDate: require("assets/image/compute-date.png"),
  computeDateadd: require("assets/image/compute-dateadd.png"),
  computeDatediff: require("assets/image/compute-datediff.png"),
  computeDateValue: require("assets/image/compute-datevalue.png"),
  computeDateFormat: require("assets/image/compute-dateformat.png"),
  computeDatetrunc: require("assets/image/compute-datetrunc.png"),
  computeDay: require("assets/image/compute-day.png"),
  computeDayOfWeek: require("assets/image/compute-dayofweek.png"),
  computeDayOfYear: require("assets/image/compute-dayofyear.png"),
  computeEndOfMonth: require("assets/image/compute-endofmonth.png"),
  computeHour: require("assets/image/compute-hour.png"),
  computeNow: require("assets/image/compute-now.png"),
  computeQuarter: require("assets/image/compute-quarter.png"),
  computeWeekOfYear: require("assets/image/compute-weekofyear.png"),
  computeYaer: require("assets/image/compute-year.png"),
  computeSecond: require("assets/image/compute-second.png"),
  computeMonth: require("assets/image/compute-month.png"),
  computeMinute: require("assets/image/compute-minute.png"),
  computeToday: require("assets/image/compute-today.png"),
  computeIsBlank: require("assets/image/compute-isblank.png"),
  computeIsNumber: require("assets/image/compute-isnumber.png"),
  computeIsText: require("assets/image/compute-istext.png"),
  computeAnd: require("assets/image/compute-and.png"),
  computeIf: require("assets/image/compute-if.png"),
  computeIfError: require("assets/image/compute-iferror.png"),
  computeNot: require("assets/image/compute-not.png"),
  computeOr: require("assets/image/compute-or.png"),
  computeAbs: require("assets/image/compute-abs.png"),
  computePower: require("assets/image/compute-power.png"),
  computeMidnight: require("assets/image/compute-midnight.png"),
  computeMindate: require("assets/image/compute-mindate.png"),
  computeIsDate: require("assets/image/compute-isdate.png"),
  computeIsNull: require("assets/image/compute-isnull.png"),
  computeCeiling: require("assets/image/compute-ceiling.png"),
  computeExp: require("assets/image/compute-exp.png"),
  computeFloor: require("assets/image/compute-floor.png"),
  computeInt: require("assets/image/compute-int.png"),
  computeLn: require("assets/image/compute-ln.png"),
  computeMod: require("assets/image/compute-mod.png"),
  computeLog10: require("assets/image/compute-log10.png"),
  computeRound: require("assets/image/compute-round.png"),
  computeRoundDown: require("assets/image/compute-rounddown.png"),
  computeRoundUp: require("assets/image/compute-roundup.png"),
  computeSign: require("assets/image/compute-sign.png"),
  computeSqrt: require("assets/image/compute-sqrt.png"),
  computeSum: require("assets/image/compute-sum.png"),
  computeAverage: require("assets/image/compute-average.png"),
  computeMax: require("assets/image/compute-max.png"),
  computeMin: require("assets/image/compute-min.png"),
  computeChar: require("assets/image/compute-char.png"),
  computeConcatenate: require("assets/image/compute-concatenate.png"),
  computeFind: require("assets/image/compute-find.png"),
  computeLeft: require("assets/image/compute-left.png"),
  computeLen: require("assets/image/compute-len.png"),
  computeLower: require("assets/image/compute-lower.png"),
  computeMid: require("assets/image/compute-mid.png"),
  computePadLeft: require("assets/image/compute-padleft.png"),
  computePadRight: require("assets/image/compute-padright.png"),
  computeRegExp: require("assets/image/compute-regexp.png"),
  computeRegexpExtract: require("assets/image/compute-regexpextract.png"),
  computeRegexpReplace: require("assets/image/compute-regexpreplace.png"),
  computeReplace: require("assets/image/compute-replace.png"),
  computeReverse: require("assets/image/compute-reverse.png"),
  computeRight: require("assets/image/compute-right.png"),
  computeStr: require("assets/image/compute-str.png"),
  computeTrim: require("assets/image/compute-trim.png"),
  computeTrimLeft: require("assets/image/compute-trimleft.png"),
  computeTrimRight: require("assets/image/compute-trimright.png"),
  computeUpper: require("assets/image/compute-upper.png"),
  computeValue: require("assets/image/compute-value.png"),
  computeSearch: require("assets/image/compute-search.png"),
};
